{
  "familyId": "STU-MINDMAP",
  "questions": [
    {
      "id": "STU-MINDMAP-001",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "multiple_choice",
      "question": "Kijk naar de mindmap. Wat hoort er op het paarse vlak in het midden te staan?",
      "options": ["Het hoofdonderwerp", "De details", "De conclusie", "De bronnen"],
      "correctAnswer": 0,
      "context": "Opbouw van een mindmap",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.mindmap-details-in-midden", "label": "Denkt dat details in het midden staan", "optionIndex": 1 },
          { "id": "stu.mindmap-conclusie-in-midden", "label": "Verwart mindmap met samenvatting (conclusie)", "optionIndex": 2 },
          { "id": "stu.mindmap-bronnen-in-midden", "label": "Verwart mindmap met bronnenlijst", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "mindmap",
          "showWhen": "always",
          "data": {
            "topic": "?",
            "branches": [
              { "label": "Tak 1" },
              { "label": "Tak 2" },
              { "label": "Tak 3" },
              { "label": "Tak 4" }
            ],
            "showLeaves": false,
            "highlightCenter": true,
            "label": "Een lege mindmap"
          }
        }
      ],
      "supportAids": [
        {
          "type": "mindmap",
          "showWhen": "wrong",
          "data": {
            "topic": "Hoofdonderwerp",
            "branches": [
              { "label": "Deel 1" },
              { "label": "Deel 2" },
              { "label": "Deel 3" }
            ],
            "showLeaves": false,
            "highlightCenter": true,
            "label": "Midden = hoofdonderwerp"
          }
        }
      ],
      "conceptId": "mindmap_midden",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "In het midden van een mindmap staat altijd het hoofdonderwerp. Van daaruit vertakken de deelonderwerpen, en aan die takken hangen de details. Check: vraag jezelf af welk woord het hele onderwerp samenvat — dat hoort in het midden, niet de details of de conclusie.",
        "solutionSteps": [
          "Midden = hoofdonderwerp",
          "Hoofdtakken = deelonderwerpen",
          "Kleine pillen op de takken = details",
          "Check: past het woord als overkoepelende titel? Dan hoort het in het midden."
        ],
        "distractorExplanations": {
          "0": "Goed! Het hoofdonderwerp staat in het midden.",
          "1": "Details staan juist aan de uiteinden van de takken, niet in het midden. Onthoud: van groot (midden) naar klein (buitenkant).",
          "2": "Een mindmap is een overzicht, geen samenvatting met conclusie. Mindmaps hebben geen 'einde' of conclusie in het midden.",
          "3": "Bronnen vermeld je apart, niet in de mindmap. Een mindmap toont je eigen indeling van het onderwerp."
        }
      }
    },
    {
      "id": "STU-MINDMAP-002",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "multiple_choice",
      "question": "Waarom hebben de takken in deze mindmap verschillende kleuren?",
      "options": ["Om de deelonderwerpen visueel te scheiden", "Omdat het er mooier uitziet", "Omdat de leraar het verplicht", "Om meer woorden te kunnen schrijven"],
      "correctAnswer": 0,
      "context": "Functie van kleuren in een mindmap",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.mindmap-kleur-als-decoratie", "label": "Denkt dat kleuren alleen decoratie zijn", "optionIndex": 1 },
          { "id": "stu.mindmap-kleur-verplicht", "label": "Denkt dat kleuren verplicht zijn", "optionIndex": 2 },
          { "id": "stu.mindmap-kleur-meer-tekst", "label": "Verwart kleur met tekstcapaciteit", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "mindmap",
          "showWhen": "always",
          "data": {
            "topic": "Het Weer",
            "branches": [
              { "label": "Zon", "leaves": ["warm", "licht"] },
              { "label": "Regen", "leaves": ["nat", "wolken"] },
              { "label": "Wind", "leaves": ["zacht", "storm"] },
              { "label": "Sneeuw", "leaves": ["koud", "wit"] }
            ],
            "label": "Mindmap met gekleurde takken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "mindmap",
          "showWhen": "wrong",
          "data": {
            "topic": "Het Weer",
            "branches": [
              { "label": "Zon", "leaves": ["warm", "licht"] },
              { "label": "Regen", "leaves": ["nat", "wolken"] },
              { "label": "Wind", "leaves": ["zacht", "storm"] },
              { "label": "Sneeuw", "leaves": ["koud", "wit"] }
            ],
            "label": "Elke hoofdtak heeft een eigen kleur — details erfvan de kleur"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kleuren in mindmaps",
            "content": "Elk deelonderwerp krijgt zijn eigen kleur. Zo zie je in één oogopslag welke details bij welke hoofdtak horen. Kleuren zijn dus geen versiering — ze helpen je structuur te zien.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "mindmap_kleuren",
      "variantIndex": 2,
      "citoDifficulty": 0.44,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Kleuren maken de structuur overzichtelijker. Elke hoofdtak krijgt een eigen kleur, zodat je snel ziet welke details bij elkaar horen. Dat is een leertechniek, geen versiering. Check: als je de kleuren weghaalt, kun je dan nog steeds snel zien welke details bij welke tak horen? Kleur helpt je hersenen groeperen.",
        "solutionSteps": [
          "Eén kleur per hoofdtak",
          "Details krijgen dezelfde kleur als hun tak",
          "Resultaat: structuur in één oogopslag",
          "Check: kleur dient een groepeer-functie, niet decoratie."
        ],
        "distractorExplanations": {
          "0": "Goed! Kleuren maken de deelonderwerpen visueel te onderscheiden.",
          "1": "Kleuren zijn niet alleen voor het oog — ze hebben een functie: groeperen.",
          "2": "Kleuren zijn een handige techniek, niet verplicht. Maar mét kleur leer je vaak beter.",
          "3": "Kleuren zeggen niets over hoeveelheid woorden. Mindmaps werken juist met kérnwoorden, niet met veel tekst."
        }
      }
    },
    {
      "id": "STU-MINDMAP-003",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "multiple_choice",
      "question": "Wat schrijf je het beste op de takken van een mindmap?",
      "options": ["Kernwoorden", "Hele zinnen", "Paginanummers", "Vragen"],
      "correctAnswer": 0,
      "context": "Kernwoorden in een mindmap",
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "stu.mindmap-hele-zinnen-op-takken", "label": "Denkt dat hele zinnen op takken horen", "optionIndex": 1 },
          { "id": "stu.mindmap-paginanummers", "label": "Verwart mindmap met inhoudsopgave", "optionIndex": 2 },
          { "id": "stu.mindmap-vragen-als-takken", "label": "Verwart mindmap met vragenstrategie (KWL)", "optionIndex": 3 }
        ]
      },
      "stimulusAids": [
        {
          "type": "mindmap",
          "showWhen": "always",
          "data": {
            "topic": "Vakantie",
            "branches": [
              { "label": "Zee", "leaves": ["zwemmen", "schelpen"] },
              { "label": "Berg", "leaves": ["wandelen", "skiën"] },
              { "label": "Stad", "leaves": ["museum", "winkels"] }
            ],
            "label": "Mindmap met kernwoorden"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Kernwoorden",
            "content": "Op de takken schrijf je kernwoorden — korte, belangrijke woorden die het onderwerp samenvatten. Geen hele zinnen!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "mindmap_kernwoorden",
      "variantIndex": 3,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Op de takken schrijf je kernwoorden — korte, sterke woorden. Hele zinnen passen niet en maken de mindmap onleesbaar. Eén woord per tak is vaak al genoeg.",
        "solutionSteps": [
          "Tak = 1 kernwoord",
          "Kort en krachtig",
          "Geen hele zinnen"
        ],
        "distractorExplanations": {
          "0": "Goed! Kernwoorden op de takken.",
          "1": "Hele zinnen maken de mindmap te vol en onoverzichtelijk. Onthoud: kernwoorden, geen zinnen.",
          "2": "Paginanummers zijn voor bronvermeldingen of een inhoudsopgave, niet voor een mindmap.",
          "3": "Vragen kun je apart noteren (KWL-strategie), maar op de mindmap-takken staan kernwoorden — antwoorden in steekwoorden."
        }
      }
    },
    {
      "id": "STU-MINDMAP-004",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "categorize",
      "question": "Je maakt een mindmap over 'Het menselijk lichaam'. Sleep elk woord naar de juiste hoofdtak.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Spijsvertering", "Ademhaling", "Bloedsomloop", "Zintuigen"],
        "items": [
          { "text": "Maag", "correctCategory": 0 },
          { "text": "Darmen", "correctCategory": 0 },
          { "text": "Long", "correctCategory": 1 },
          { "text": "Luchtpijp", "correctCategory": 1 },
          { "text": "Hart", "correctCategory": 2 },
          { "text": "Bloedvaten", "correctCategory": 2 },
          { "text": "Oog", "correctCategory": 3 },
          { "text": "Oor", "correctCategory": 3 }
        ]
      },
      "context": "Organen koppelen aan stelsels (Blink-stijl)",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": []
      },
      "stimulusAids": [
        {
          "type": "mindmap",
          "showWhen": "always",
          "data": {
            "topic": "Menselijk lichaam",
            "branches": [
              { "label": "Spijsvertering" },
              { "label": "Ademhaling" },
              { "label": "Bloedsomloop" },
              { "label": "Zintuigen" }
            ],
            "showLeaves": false,
            "label": "Vul de mindmap"
          }
        }
      ],
      "supportAids": [
        {
          "type": "mindmap",
          "showWhen": "wrong",
          "data": {
            "topic": "Menselijk lichaam",
            "branches": [
              { "label": "Spijsvertering", "leaves": ["Maag", "Darmen"] },
              { "label": "Ademhaling", "leaves": ["Long", "Luchtpijp"] },
              { "label": "Bloedsomloop", "leaves": ["Hart", "Bloedvaten"] },
              { "label": "Zintuigen", "leaves": ["Oog", "Oor"] }
            ],
            "label": "Correcte mindmap"
          }
        }
      ],
      "conceptId": "mindmap_categoriseren",
      "variantIndex": 4,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Organen horen bij stelsels: maag en darmen → spijsvertering, long en luchtpijp → ademhaling, hart en bloedvaten → bloedsomloop, oog en oor → zintuigen. Dit is precies hoe je een mindmap opbouwt: hoofdtak = stelsel, leaf = orgaan.",
        "solutionSteps": [
          "Spijsvertering: maag, darmen",
          "Ademhaling: long, luchtpijp",
          "Bloedsomloop: hart, bloedvaten",
          "Zintuigen: oog, oor"
        ]
      }
    },
    {
      "id": "STU-MINDMAP-005",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "ordering",
      "question": "Zet de stappen voor het maken van een mindmap in de juiste volgorde.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          "Schrijf het hoofdonderwerp in het midden",
          "Bedenk 3-5 deelonderwerpen als hoofdtakken",
          "Voeg details toe aan elke tak",
          "Gebruik kleuren en symbolen voor overzicht"
        ],
        "correctOrder": [0, 1, 2, 3]
      },
      "context": "Mindmap-stappen",
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": []
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "mindmap",
          "showWhen": "wrong",
          "data": {
            "topic": "Mijn onderwerp",
            "branches": [
              { "label": "Deel 1", "leaves": ["detail"] },
              { "label": "Deel 2", "leaves": ["detail"] },
              { "label": "Deel 3", "leaves": ["detail"] }
            ],
            "label": "Eindresultaat: hoofd → takken → details → kleuren"
          }
        }
      ],
      "conceptId": "mindmap_stappen",
      "variantIndex": 5,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Mindmap maken: 1) Hoofdonderwerp centraal, 2) Hoofdtakken, 3) Details, 4) Kleuren. Van groot (middelste idee) naar klein (details). Kleuren komen op het laatst — anders denk je teveel na over uiterlijk en te weinig over inhoud.",
        "solutionSteps": [
          "1. Hoofdonderwerp in het midden",
          "2. Deelonderwerpen als takken",
          "3. Details toevoegen",
          "4. Kleuren en symbolen"
        ]
      }
    },
    {
      "id": "STU-MINDMAP-006",
      "familyId": "STU-MINDMAP",
      "module": "Studievaardig",
      "tier": 13,
      "levelCode": "B8",
      "group": 8,
      "skill": "leerstrategieen",
      "subSkill": "leer_mindmap",
      "questionType": "categorize",
      "question": "Sleep elk detail naar de hoofdtak waar het bij hoort in de mindmap.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": [
          "Zon",
          "Regen",
          "Wind",
          "Sneeuw"
        ],
        "items": [
          { "id": "i1", "text": "hagel", "correctCategory": 1 },
          { "id": "i2", "text": "storm", "correctCategory": 2 },
          { "id": "i3", "text": "zonnebrand", "correctCategory": 0 },
          { "id": "i4", "text": "ijspegel", "correctCategory": 3 },
          { "id": "i5", "text": "bries", "correctCategory": 2 },
          { "id": "i6", "text": "warmte", "correctCategory": 0 }
        ]
      },
      "context": "Detail-leaves toewijzen aan correcte mindmap-hoofdtak",
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "stu.mindmap-details-in-midden", "label": "Plaatst detail in midden i.p.v. onder hoofdtak" },
          { "id": "stu.mindmap-kleur-als-decoratie", "label": "Sorteert op kleur i.p.v. betekenis" }
        ]
      },
      "stimulusAids": [
        {
          "type": "mindmap",
          "showWhen": "always",
          "data": {
            "topic": "Het Weer",
            "branches": [
              { "label": "Zon", "leaves": ["warm", "licht"] },
              { "label": "Regen", "leaves": ["nat", "plas"] },
              { "label": "Wind", "leaves": ["bries", "kracht"] },
              { "label": "Sneeuw", "leaves": ["koud", "wit"] }
            ],
            "showLeaves": true,
            "label": "Mindmap: Het Weer"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Details horen onder de juiste hoofdtak",
            "content": "Elk detail (leaf) hangt onder één hoofdtak — de tak die het beste past bij de betekenis. Veel leerlingen geven hun hoofdtakken een eigen kleur (handige techniek!), maar bij het sorteren is de betekenis leidend: stop het detail bij de tak waar het inhoudelijk bij past, en gebruik dezelfde kleur als die tak.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "mindmap_details_sorteren",
      "variantIndex": 6,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Elke nieuwe leaf hoort onder de hoofdtak waar het natuurlijk bij past: hagel/regen, storm+bries/wind, zonnebrand+warmte/zon, ijspegel/sneeuw. Een mindmap groepeert op betekenis — niet op kleur of vorm.",
        "solutionSteps": [
          "1. Lees het detail",
          "2. Vraag: bij welk hoofdonderwerp hoort dit logisch?",
          "3. Sleep het detail naar die hoofdtak"
        ]
      }
    }
  ]
}